import { trackInteraction } from 'client/javascript/analytics';
import { getLocale } from 'client/javascript/util/locale';
import getClosestMarket from 'client/javascript/get_closest_market';
import {
  SELECT_LOCATION_BTN,
  LOCATION_DROPDOWN_ID,
  getLocationDropdownSelectedId,
  getLocationDropdownSelectedName
} from './utils';

const locale = getLocale();

export async function setupWizardTrackingEvents() {
  //  Location Change Tracking Event
  const locationDropdown = document.getElementById(LOCATION_DROPDOWN_ID);
  locationDropdown.addEventListener('click', () => {
    trackInteraction({
      label: 'segmentor form interaction market'
    });
  });

  // Wizard Form Submitted
  const checkAvailabilityBtn = document.getElementById(SELECT_LOCATION_BTN);
  checkAvailabilityBtn.addEventListener('click', async () => {
    const closestLocation = (await getClosestMarket()) || {};
    const selectedLocationId = getLocationDropdownSelectedId();
    const selectedLocationName = getLocationDropdownSelectedName();

    trackInteraction({
      label: 'segmentor form submitted',
      locale,
      marketName: selectedLocationName,
      marketID: selectedLocationId,
      isGeolocatedMarket: closestLocation.name === selectedLocationName
    });
  });
}

export default setupWizardTrackingEvents;
